import { render, staticRenderFns } from "./extractDialog.vue?vue&type=template&id=711affe7&scoped=true"
import script from "./extractDialog.vue?vue&type=script&lang=js"
export * from "./extractDialog.vue?vue&type=script&lang=js"
import style0 from "./extractDialog.vue?vue&type=style&index=0&id=711affe7&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "711affe7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('711affe7')) {
      api.createRecord('711affe7', component.options)
    } else {
      api.reload('711affe7', component.options)
    }
    module.hot.accept("./extractDialog.vue?vue&type=template&id=711affe7&scoped=true", function () {
      api.rerender('711affe7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/governance/vote/extractDialog.vue"
export default component.exports